// Testimonials rendering from JSON data and carousel functionality
(function() {
  'use strict';

  let currentIndex = 0;
  let testimonials = [];
  let autoScrollInterval = null;
  let track = null;
  let prevButton = null;
  let nextButton = null;
  let itemsPerView = 3;

  function updateItemsPerView() {
    const width = window.innerWidth;
    if (width <= 640) {
      itemsPerView = 1;
    } else if (width <= 980) {
      itemsPerView = 2;
    } else {
      itemsPerView = 3;
    }
  }

  function getMaxIndex() {
    return Math.max(0, testimonials.length - itemsPerView);
  }

  function updateCarouselPosition() {
    if (!track || track.children.length === 0) return;
    
    // Calculate translateX based on item width and gap
    const firstItem = track.children[0];
    if (!firstItem) return;
    
    const itemWidth = firstItem.offsetWidth;
    const gap = parseFloat(getComputedStyle(track).gap) || 16;
    const translateX = -(currentIndex * (itemWidth + gap));
    
    track.style.transform = `translateX(${translateX}px)`;
    
    // Buttons are never disabled in infinite loop mode
    if (prevButton) {
      prevButton.disabled = false;
    }
    if (nextButton) {
      nextButton.disabled = false;
    }
  }

  function nextSlide() {
    const maxIndex = getMaxIndex();
    if (testimonials.length <= itemsPerView) {
      // If all items fit, no need to scroll
      return;
    }
    
    // Loop infinitely
    if (currentIndex >= maxIndex) {
      currentIndex = 0; // Loop back to start
    } else {
      currentIndex++;
    }
    updateCarouselPosition();
    resetAutoScroll();
  }

  function prevSlide() {
    const maxIndex = getMaxIndex();
    if (testimonials.length <= itemsPerView) {
      // If all items fit, no need to scroll
      return;
    }
    
    // Loop infinitely
    if (currentIndex <= 0) {
      currentIndex = maxIndex; // Loop to end
    } else {
      currentIndex--;
    }
    updateCarouselPosition();
    resetAutoScroll();
  }

  function startAutoScroll() {
    // Clear existing interval
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
    }
    
    // Only auto-scroll if there are more items than visible
    if (testimonials.length > itemsPerView) {
      autoScrollInterval = setInterval(function() {
        const maxIndex = getMaxIndex();
        if (currentIndex >= maxIndex) {
          currentIndex = 0; // Loop back to start
        } else {
          currentIndex++;
        }
        updateCarouselPosition();
      }, 5000); // Auto-scroll every 5 seconds
    }
  }

  function resetAutoScroll() {
    startAutoScroll();
  }

  function pauseAutoScroll() {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
      autoScrollInterval = null;
    }
  }

  function initTestimonials() {
    const testimonialsSection = document.querySelector('.gh-testimonials');
    if (!testimonialsSection) return;

    const testimonialsScript = document.getElementById('testimonials-data');
    if (!testimonialsScript) return;

    try {
      testimonials = JSON.parse(testimonialsScript.textContent);
      const container = document.getElementById('testimonials-container');
      
      if (!container || !Array.isArray(testimonials) || testimonials.length === 0) {
        return;
      }

      track = container;
      prevButton = testimonialsSection.querySelector('.gh-testimonials-nav-prev');
      nextButton = testimonialsSection.querySelector('.gh-testimonials-nav-next');

      // Clear any existing content
      container.innerHTML = '';

      // Render each testimonial
      testimonials.forEach(function(testimonial) {
        if (!testimonial.name || !testimonial.quote) {
          return; // Skip invalid testimonials
        }

        const testimonialEl = document.createElement('article');
        testimonialEl.className = 'gh-testimonial';

        // Create stars
        const starsContainer = document.createElement('div');
        starsContainer.className = 'gh-testimonial-stars';
        for (let i = 0; i < 5; i++) {
          const star = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          star.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          star.setAttribute('width', '16');
          star.setAttribute('height', '16');
          star.setAttribute('viewBox', '0 0 24 24');
          star.setAttribute('fill', 'currentColor');
          star.style.fill = '#ffd700';
          star.style.color = '#ffd700';
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z');
          star.appendChild(path);
          starsContainer.appendChild(star);
        }
        testimonialEl.appendChild(starsContainer);

        const blockquote = document.createElement('blockquote');
        blockquote.className = 'gh-testimonial-quote';
        
        const quoteP = document.createElement('p');
        quoteP.textContent = testimonial.quote;
        blockquote.appendChild(quoteP);

        const footer = document.createElement('footer');
        footer.className = 'gh-testimonial-author';

        const cite = document.createElement('cite');
        cite.className = 'gh-testimonial-name';
        cite.textContent = testimonial.name;

        footer.appendChild(cite);

        if (testimonial.profession) {
          const profession = document.createElement('span');
          profession.className = 'gh-testimonial-profession';
          profession.textContent = testimonial.profession;
          footer.appendChild(profession);
        }

        testimonialEl.appendChild(blockquote);
        testimonialEl.appendChild(footer);
        container.appendChild(testimonialEl);
      });

      // Set up navigation buttons
      if (prevButton) {
        prevButton.addEventListener('click', function() {
          prevSlide();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function() {
          nextSlide();
        });
      }

      // Pause auto-scroll on hover
      testimonialsSection.addEventListener('mouseenter', pauseAutoScroll);
      testimonialsSection.addEventListener('mouseleave', startAutoScroll);

      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          updateItemsPerView();
          updateCarouselPosition();
        }, 250);
      });

      // Initialize after a brief delay to ensure DOM is fully rendered
      setTimeout(function() {
        updateItemsPerView();
        updateCarouselPosition();
        startAutoScroll();
      }, 100);
    } catch (error) {
      console.error('Error parsing testimonials JSON:', error);
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonials);
  } else {
    initTestimonials();
  }
})();

